module.exports = __webpack_public_path__ + "logo.png?0f2d7a27fd82d6f15e763fcd605f8002";